import React from 'react';

const CouponSection = () => (
  <div className="bg-white border border-[#E0E0E0] rounded-[10px] p-6 md:p-10 mb-6 md:mb-10 text-center shadow-sm animate-in fade-in duration-500">
    <h2 className="text-center text-[20px] md:text-[24px] font-[500] tracking-tight text-[#000000] mb-2 font-inter ">
        Special Offers for You!
    </h2>
    <p className="text-[14px] md:text-[18px] tracking-tight text-[#333333] mb-6 font-[500] px-2">
        Apply coupon code to get additional discount
    </p>
    <div className="flex flex-col sm:flex-row max-w-md mx-auto border border-[black] rounded-[8px] overflow-hidden">
      <input 
        type="text" 
        placeholder="Enter coupon code" 
        className="flex-1 px-4 py-3 outline-none text-[14px] md:text-[15px] font-medium placeholder:text-[black] border-b sm:border-b-0 sm:border-r border-[#4096F6]"
      />
      <button className="bg-[#4096F6] text-white px-6 md:px-8 py-3 font-[500] text-[14px] md:text-[18px] tracking-tight hover:bg-[#2563EB] transition-all active:scale-95 whitespace-nowrap">
        Apply Coupon
      </button>
    </div>
  </div>
);

export default CouponSection;